import keyMirror from '../../utils/keyMirror';

export default keyMirror({

    USER_PROFILE_SUCCESS: null,
    IS_USER_AUTHORIZED_SUCCESS: null,

    REQUEST_CONFIGURATION: null,
    REQUEST_CONFIGURATION_SUCCESS: null,
    REQUEST_CONFIGURATION_FAILURE: null,

    // Modals
    SHOW_MODAL: null,
    HIDE_MODAL: null,
    UPDATE_INPUTS_MODAL: null,
    UPDATE_TITLE: null,

    // Toast messages
    SHOW_TOAST: null,
    HIDE_EXPIRED_TOASTS: null,

    MANAGE_THEME: null,

    SET_VIEW: null,

    SET_FILTER_ALL_WINDOW: null,
    SET_FILTER_MY_WINDOW: null,

    SET_DATA_RELOAD: null
});